module.exports = __webpack_public_path__ + "img/ghostmarket-icon.0e50c7b3.svg";